import React from 'react';
import Box from '@material-ui/core/Box';

const BlankLayout = (props) => {
  return <Box width={'100vw'} display={'flex'} justifyContent={'center'} py={4} {...props} />;
};

export default BlankLayout;
